<template>
  <div class="page-prj-list">
    <!-- <a-button-group class="v-mt-sm">
      <a-button @click="tab = 'going'" :type="tab == 'going' ? 'primary' : 'default'">进行中</a-button>
      <a-button @click="tab = 'closed'" :type="tab == 'closed' ? 'primary' : 'default'">已结束</a-button>
    </a-button-group> -->
    <div class="list-options v-mt-sm w100">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="培训班名称"><a-input placeholder="培训班名称" @keyup.enter="handleSearch" allow-clear v-model="form.name" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="培训班类型">
              <a-select placeholder="请选择" v-model="form.classType" size="default" style="width: 200px" allow-clear>
                <a-select-option :value="1">项目评审</a-select-option>
                <a-select-option :value="2">项目协议</a-select-option>
                <a-select-option :value="7">项目执行</a-select-option>
                <a-select-option :value="8">项目结项</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="主讲老师"><a-input placeholder="老师姓名" @keyup.enter="handleSearch" allow-clear v-model="form.teacher" size="default" style="width: 200px" /></a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="开课时间段">
              <a-range-picker :placeholder="['起始时间', '结束时间']" size="default" style="width: 200px" @change="onStartDateRangeChange" />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="截止时间段">
              <a-range-picker :placeholder="['起始时间', '结束时间']" size="default" style="width: 200px" @change="onEndDateRangeChange" />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="项目阶段">
              <a-select placeholder="请选择" v-model="form.state" size="default" style="width: 200px" allow-clear>
                <template v-if="tab == 'going'">
                  <a-select-option :value="7">培训中</a-select-option>
                  <a-select-option :value="8">结业中</a-select-option>
                </template>
                <template v-else-if="tab == 'closed'">
                  <a-select-option :value="9">已结业</a-select-option>
                  <a-select-option :value="-1">已终止</a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <a-space>
        <a-button type="indigo" icon="link" size="small" v-if="hasPermission('project:main:talent:sub:relation')" @click="selectorModal = true">关联子项目</a-button>
        <a-button type="indigo" icon="plus" size="small" v-if="hasPermission('project:own:talent:draft')" @click="$router.push(`../sub/draft?pid=${projectId}`)">创建子项目</a-button>
      </a-space>
      <a-space class="v-ml-auto">
        <a-button type="primary" icon="search" size="small" @click="handleSearch">查询</a-button>
        <!-- <a-button icon="plus" type="primary" size="small" @click="$router.push('add')" v-hasPermission="['project:own:new']">新增项目</a-button> -->
        <!-- <a-button icon="file-excel" type="indigo" size="small" @click="exportData">导出</a-button> -->
      </a-space>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="id">
        <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
          <template slot-scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column title="操作" data-index="action" :width="140" align="left" fixed="left">
          <template slot-scope="text, record">
            <a-space class="table-actions" :size="10">
              <span class="hover-line text-indigo" v-if="hasPermission('project:main:talent:sub:remove')" @click="removePrj(record)">移除</span>
              <template v-if="record.state == 0">
                <span class="hover-line text-indigo" title="编辑" @click="$router.push(`/project/own/talent/draft?id=${record.id}`)">编辑</span>
                <span class="hover-line text-red" title="删除" @click="handleDel(record.id)">删除</span>
              </template>
              <span class="hover-line text-indigo" title="项目审核" @click="$router.push(`/project/own/talent/review?id=${record.id}`)" v-else-if="record.state === 1">项目评审</span>
              <span class="hover-line text-indigo" title="上传项目协议" @click="$router.push(`/project/own/talent/contract?id=${record.id}`)" v-else-if="record.state === 2">处理</span>
              <span class="hover-line text-indigo" title="管理" @click="$router.push(`/project/own/talent/view?id=${record.id}`)" v-else-if="record.state === 7 || record.state === 8">管理</span>
              <span class="hover-line text-indigo" title="查看" @click="$router.push(`/project/own/talent/view?id=${record.id}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
        <a-table-column title="项目状态" data-index="state" align="left" :width="110" fixed="left">
          <template slot-scope="text">
            <span class="text-grey" v-if="text === -1">已终止</span>
            <span class="text-red" v-else-if="text === 0">待提交</span>
            <span class="text-red" v-else-if="text === 7">培训中</span>
            <span class="text-red" v-else-if="text === 8">结业中</span>
            <span class="text-red" v-else-if="text === 9">已结业</span>
          </template>
        </a-table-column>
        <a-table-column title="项目编号" data-index="code" :width="115" :ellipsis="true" align="left" fixed="left"/>
        <a-table-column title="培训班名称" data-index="name" :width="300" :ellipsis="true" align="left" fixed="left">
          <template slot-scope="text, record">
            <router-link class="text-indigo hover-line" :title="text" :to="{ path: '/project/own/talent/view', query: { id: record.id } }">{{ text }}</router-link>
          </template>
        </a-table-column>
        <a-table-column title="培训班类型" data-index="talentInfo.classType" :ellipsis="true" align="left" />
        <a-table-column title="课时数量" data-index="talentInfo.classHour" :width="80" align="right" />
        <a-table-column title="开课时间" data-index="startDate" :width="130" :ellipsis="true" align="left">
          <template slot-scope="text, record">
            {{ record.startDate ? record.startDate.substring(0, 16) : '' }}
          </template>
        </a-table-column>
        <a-table-column title="截止时间" data-index="endDate" :width="130" align="left" >
          <template slot-scope="text, record">
            {{ record.endDate ? record.endDate.substring(0, 16) : '' }}
          </template>
        </a-table-column>
        <a-table-column title="主讲老师" data-index="talentInfo.teacher" :width="90" align="left" />
        <a-table-column title="主讲老师手机" data-index="talentInfo.teacherPhone" :width="105" :ellipsis="true" align="left" />
        <a-table-column title="授课方式" data-index="talentInfo.teachingMethod" :width="100" :ellipsis="true" align="left" />
        <a-table-column title="预算金额" data-index="budgetAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span v-if="record.budgetAmount">{{ $utils.thousands(record.budgetAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="请款金额" data-index="appliedAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span v-if="record.budgetAmount">{{ $utils.thousands(record.appliedAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="实际支出金额" data-index="expensedAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span v-if="record.budgetAmount">{{ $utils.thousands(record.expensedAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="请款余额" data-index="remainApplyAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-red': record.appliedAmount - record.expensedAmount }" v-if="record.budgetAmount">{{ $utils.thousands(record.appliedAmount - record.expensedAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="差额" data-index="remainAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span v-if="record.budgetAmount">{{ $utils.thousands(record.budgetAmount - record.expensedAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="子项目分摊费" data-index="shareAmount" :width="119" align="right">
          <template slot-scope="text, record">
            <span class="text-indigo" v-if="record.shareAmount">{{ $utils.thousands(record.shareAmount) }}</span>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column title="创建日期" data-index="createTime" :width="90" align="center">
          <template slot-scope="text, record">
            {{ record.createTime ? record.createTime.substring(0, 10) : '' }}
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
      </div>
    </div>
    <project-selector :project-id="projectId" :type="21" v-model="selectorModal" @submit="onSelectorSubmit" />
  </div>
</template>

<script>
import { clearPrjSubs } from '@/api/project/common'
import { listPrj } from '@/api/project/talent'
const form = {
  name: '',
  teacher: '',
  classType: undefined,
  state: undefined,
  fromStartDate: undefined,
  toStartDate: undefined,
  fromEndDate: undefined,
  toEndDate: undefined,
}
const TAB_STATE = {
  all: null,
  going: [0, 1, 2, 7, 8],
  closed: [-1, 9],
}
export default {
  data() {
    return {
      tab: 'all',
      loading: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      form: { ...form },
      tabs: [],
      selectorModal: false,
    }
  },
  watch: {
    tab() {
      this.form = { ...form }
      this.load()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
        // this.tab = this.$route.query.tab || 'going'
      }
    },
    handleSearch() {
      this.load()
    },
    load(page = 1, pageSize = 10, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize: -1,
        sorter,
        pid: this.projectId,
        ...this.form,
      }
      if (this.tab !== 'all') {
        params.states = TAB_STATE[this.tab]
      }
      listPrj(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onSelectorSubmit() {
      this.selectorModal = false
      this.load()
      this.$root.$emit('reloadPrj')
    },
    removePrj(record) {
      this.$confirm({
        title: `确认移除子项目【${record.name}】？`,
        centered: true,
        onOk: () => {
          // 异步关闭
          let params = {
            projectId: this.projectId,
            ids: [record.id],
          }
          return new Promise((resolve, reject) => {
            clearPrjSubs(params)
              .then(({ data }) => {
                if (data.success) {
                  this.$message.success('操作成功')
                  this.load()
                  resolve()
                } else {
                  this.$message.warning(data.msg)
                  reject()
                }
              })
              .catch(err => {
                if (err) {
                  this.$message.warning(err)
                }
                reject()
              })
          }).catch(() => {})
        },
      })
    },
    onStartDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.fromStartDate = startDate
      this.form.toStartDate = endDate
    },
    onEndDateRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.fromEndDate = startDate
      this.form.toEndDate = endDate
    },
  },
  created () {
    this.init()
  },
}
</script>
